 /*
 Create By Sittikron : 06/06/2023
 Update By Sittikron : 9/08/2023  - เพิ่ม Permissionในการตรวจสอบ
 Update By POOM : 26/01/2024  เวลา return API    มีการใช้  status_ID === 0  ซึ่งผิด  แก้ให้ถูก คือ status_ID === 1
 
 Update By POOM : 03/05/2024  
  - เพิ่มการแสดงข้อมูลและบันทึก Rate ราคา PER DIEM  ต่อวัน   (baht/day) , Rate ราคา travel ต่อกิโลเมตร   (baht/km)
 Update BY POOM : 09-05-2024 
  - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล
  
 Update By POOM : 2024-05-13  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที
 
*/

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { Class_ETC_Decrypt 
  , Class_ETC_MsgError
  , Class_ETC_MsgSuccess
  , Class_ETC_MsgErrorfocusByID
  , Class_ETC_SessionTimeOut
  ,HtmlTooltip
} from "../Class/Class_Etc";
import Pathurl from "../Class/Pathurl.json";
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import ConfigETC from "../Class/ConfigETC.json";
import MsgDescription from "../Class/MsgDescription.json";
import CurrencyInput from 'react-currency-input-field';
import { CP_CheckPermission , } from "../Class/Class_Permission"

function M_position_ae() {

  const isSVOT = CP_CheckPermission("service_list" , ["ot"],false,false);
  const [pgAct, setPgAct] = useState("");
  const [pgpos_id, setPgpos_id] = useState(-1);
  const location = useLocation();
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [isPositionStatus, setIsPositionStatus] = useState(true);

  const [selectedTimesheet, setSelectedTimesheet] = useState("0");
  // const [selectedPayment, setSelectedPayment] = useState("-1");
  const [selectedTimeoff, setSelectedTimeoff] = useState("0");

  const [data_model_position_pos_rate_WT, setData_model_position_pos_rate_WT] = useState(0.00);
  const [data_model_position_pos_rate_OT, setData_model_position_pos_rate_OT] = useState(0.00);

  const [data_model_position_pos_rate_exp_extra, setData_model_position_pos_rate_exp_extra] = useState(0.00);
  const [data_model_position_pos_rate_exp_travel, setData_model_position_pos_rate_exp_travel] = useState(0.00);

  const [isPermissionEdit, setIsPermissionEdit] = useState(false);
  const [isPermissionAdd, setIsPermissionAdd] = useState(false);

  const onValueChange_model_position_pos_rate = (newValue , act) => {
    if (newValue === undefined) {

      if (act === "ot")
      {
        setData_model_position_pos_rate_OT("0");
      }
      else if (act === "extra")
      {
        setData_model_position_pos_rate_exp_extra("0");
      }
      else if (act === "travel")
      {
        setData_model_position_pos_rate_exp_travel("0");
      }
      else
      {
        setData_model_position_pos_rate_WT("0");
      }
    } else {
      if (act === "ot")
      {
        setData_model_position_pos_rate_OT(newValue);
      }
      else if (act === "extra")
      {
        setData_model_position_pos_rate_exp_extra(newValue);
      }
      else if (act === "travel")
      {
        setData_model_position_pos_rate_exp_travel(newValue);
      }
      else
      {
        setData_model_position_pos_rate_WT(newValue);
      }
    }
  }

  const onChange_Radio = (e , act ) => {
    if (act === "TS")
    {
      setSelectedTimesheet(e.target.value)
    }
    else if (act === "TO")
    {
      setSelectedTimeoff(e.target.value)
    }
    else
    {
      // setSelectedPayment(e.target.value)
    }
  }

  useEffect(() => {
    if (isFirst === true) {
      GetParameter(function() {
        if (pgAct !== ""){   
          let isPerView = CP_CheckPermission("master" , ["position_view"] , false , true);
          if (isPerView)
          {
            let isPerAdd = false; 
            let isPerEdit = false;

            if(pgAct === "Add" )
            {
              isPerAdd = CP_CheckPermission("master" , ["position_add"] , false , true);
              setIsPermissionAdd(isPerAdd);
            }
            else
            {
              isPerEdit = CP_CheckPermission("master" , ["position_edit"] , false , false);
              setIsPermissionEdit(isPerEdit);
            }
            GetConfig();
            if (isLoadedConfigData === true) {
              if (pgAct === "Add") {
                setIsLoadProgress(false);
              } else {
                Bind_Position_Data(function() {
                  setIsLoadProgress(false);
                });
              }
              setIsFirst(false);
            }
         }
        }
      });
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData , pgAct]);

  function GetParameter(_callback) {
    let isNullParameter = false;
    let pos_id = "";
    let act = "";
    try {
      if (location.state === null) {
        isNullParameter = true;
      } else {
        pos_id = Class_ETC_Decrypt(location.state?.pos_id.toString());
        act = Class_ETC_Decrypt(location.state?.act.toString());

        if (act === "") {
          isNullParameter = true;
        } else if (act !== "Add" && act !== "Edit") {
          isNullParameter = true;
        } else {
          if (act === "Edit" && pos_id === "") {
            isNullParameter = true;
          }
        }
      }
    } catch {
      isNullParameter = true;
    }
    if (isNullParameter) {
      window.location.replace("../" + Pathurl.m_position);
      if (_callback != null) {
          _callback();
      }
    } else {
      setPgAct(act);
      setPgpos_id(pos_id);
      if (_callback != null) {
          _callback();
      }
    }
  }

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  async function Bind_Position_Data(_callback) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        pos_id: pgpos_id.toString(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Position_Getdata",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          document.getElementById("txt_position_name").value = json.pos_name;
          setData_model_position_pos_rate_WT(json.pos_rate_WT);
          setData_model_position_pos_rate_OT(json.pos_rate_OT);

          
          setData_model_position_pos_rate_exp_extra(json.pos_rate_exp_extra);
          setData_model_position_pos_rate_exp_travel(json.pos_rate_exp_travel);

          document.getElementById("txt_position_desc").value = json.pos_desc;
          setIsPositionStatus(json.pos_status === 1 ? true : false);
          setSelectedTimesheet(json.pos_auth_timesheet.toString());
          // setSelectedPayment(json.pos_auth_payment.toString());
          setSelectedTimeoff(json.pos_auth_timeoff.toString());
          setIsLoadProgress(false);
          if (_callback != null) {
              _callback();
          }
        } else {
          window.location.replace("../" + Pathurl.m_position);
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else
      {
        window.location.replace("../" + Pathurl.m_position);
      }
    } catch {
      window.location.replace("../" + Pathurl.m_position);
    }
  }

  function onclickSavePositonAE(){
    
    setIsLoadProgress(true);
    var istxtError = "";
    var if_negative = "";
    let wtr_num = parseInt(document.getElementById("txt_Work_time_rate").value.trim())
    let ot_num = 0;
    
    if (isSVOT === true)
    {
      ot_num = parseInt(document.getElementById("txt_OT_rate").value.trim())
    }
    

    
    let pos_rate_exp_extra = parseInt(document.getElementById("txt_pos_rate_exp_extra").value.trim())
    let pos_rate_exp_travel = parseInt(document.getElementById("txt_pos_rate_exp_travel").value.trim())


    if (document.getElementById("txt_position_name").value.trim() === "")
    {
      istxtError = "txt_position_name";
    }
    else if (wtr_num < 0)
    {
      istxtError = "txt_Work_time_rate";
      if_negative = "txt_Work_time_rate";
    }
    else if (ot_num < 0)
    {
      istxtError = "txt_OT_rate";
      if_negative = "txt_OT_rate";
    }
    else if (pos_rate_exp_extra < 0)
    {
      istxtError = "txt_pos_rate_exp_extra";
      if_negative = "txt_pos_rate_exp_extra";
    }
    else if (pos_rate_exp_travel < 0)
    {
      istxtError = "txt_pos_rate_exp_travel";
      if_negative = "txt_pos_rate_exp_travel";
    }


    
    if (istxtError !== "")
    {
      if (if_negative === "txt_Work_time_rate")
      {
        setIsLoadProgress(false);
        Class_ETC_MsgErrorfocusByID(MsgDescription.ERR017 , istxtError);
      }
      else if (if_negative === "txt_OT_rate" || if_negative === "txt_pos_rate_exp_extra" || if_negative === "txt_pos_rate_exp_travel")
      {
        setIsLoadProgress(false);
        Class_ETC_MsgErrorfocusByID(MsgDescription.ERR017 , istxtError);
      }
      else
      {
        setIsLoadProgress(false);
        Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001 , istxtError);
      }
    }
    else
    {
      if (
        selectedTimesheet !== "0" && 
        selectedTimesheet !== "1" && 
        selectedTimesheet !== "2" && 
        selectedTimesheet !== "3" 
        )
      {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR013 , null);
      }
      else if (
        selectedTimeoff !== "0" && 
        selectedTimeoff !== "1" && 
        selectedTimeoff !== "2" && 
        selectedTimeoff !== "3" 
        )
        {
          setIsLoadProgress(false);
          Class_ETC_MsgError(MsgDescription.ERR014 , null);
        }
      else
      {
        SavedPosition();
      }
    }
  }

  async function SavedPosition()
  {

    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      
      let pn = document.getElementById("txt_position_name").value.trim();
      let twr = document.getElementById("txt_Work_time_rate").value.trim();

      let pos_rate_exp_extra = document.getElementById("txt_pos_rate_exp_extra").value.trim();
      let pos_rate_exp_travel = document.getElementById("txt_pos_rate_exp_travel").value.trim();

      let ot = "0";
      if (isSVOT === true)
      {
        ot = document.getElementById("txt_OT_rate").value.trim();
      }


      let ts = selectedTimesheet;
      let to = selectedTimeoff;
      let dsc = document.getElementById("txt_position_desc").value.trim();
      let ps = (isPositionStatus === true ? "1" : "0");

      var raw;   

      if (pgAct === "Add")
      {
        raw = JSON.stringify({
          "pos_name": pn,
          "pos_rate_WT": twr,
          "pos_rate_OT": ot,
          "pos_auth_timesheet": ts,
          "pos_auth_payment": "0",
          "pos_auth_timeoff": to,
          "pos_desc": dsc,
          "pos_status": ps,
          "pos_rate_exp_extra": pos_rate_exp_extra,
          "pos_rate_exp_travel": pos_rate_exp_travel,
        });
      }
      else
      {
        raw = JSON.stringify({
          "pos_id": pgpos_id,
          "pos_name": pn,
          "pos_rate_WT": twr,
          "pos_rate_OT": ot,
          "pos_auth_timesheet": ts,
          "pos_auth_payment": "0",
          "pos_auth_timeoff": to,
          "pos_desc": dsc,
          "pos_status": ps,
          "pos_rate_exp_extra": pos_rate_exp_extra,
          "pos_rate_exp_travel": pos_rate_exp_travel,
        });
      }

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + (pgAct === "Add" ? "Position_Add" : "Position_Edit"),
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {
        
        setIsLoadProgress(false);
        Class_ETC_MsgSuccess(MsgDescription.CFM001, Back_to_m_position);

      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
        
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }

  }

  function Back_to_m_position(){
    window.location.replace("../" + Pathurl.m_position);
  }
  
  function onclickCancel(){
    setIsLoadProgress(true);
    if (pgAct === "Add")
      {       
          setIsLoadProgress(false);
          document.getElementById("txt_position_name").value = "";
          setData_model_position_pos_rate_WT("0.00");
          setData_model_position_pos_rate_OT("0.00");

          
          setData_model_position_pos_rate_exp_extra("0.00");
          setData_model_position_pos_rate_exp_travel("0.00");

          document.getElementById("txt_position_desc").value = "";
          setIsPositionStatus(true);
          setSelectedTimesheet("0");
          setSelectedTimeoff("0")
      }
    else
     {
      Bind_Position_Data(function() {
        setIsLoadProgress(false);
      });
     }  
  }

  return (
    <>
    {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      <Helmet>
        <title>Position</title>
      </Helmet>
      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="container-fluid">
                <h1 className="display-5">
                  {" "}
                  <i className="fas fa-graduation-cap" /> Position{" "}
                </h1>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                {/* SELECT2 EXAMPLE */}
                <div className="card  shadow">
                  <div className="card-header">
                    <h3 className="card-title"> {pgAct} Position detail</h3>
                  </div>
                  <div className="card-body">
                    <div className="form-horizontal">
                      <div className="row">
                        <div className="col-sm-12">
                        <div className="form-group row">
                            <label className="text-sm col-sm-2 col-form-label text-right">
                              Position Name
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Position Name"
                                id="txt_position_name"
                              />
                            </div>
                          </div>
                          <div className="form-group row mb-0">
                            <label className="text-sm col-sm-2 col-form-label text-right">
                              Description{" "}
                            </label>
                            <div className="col-sm-10">
                              <textarea
                                className="form-control form-control-sm"
                                rows={2}
                                placeholder="Description ..."
                                id="txt_position_desc"
                              />
                            </div>
                          </div>

                          

                        </div>
                      </div>
                      
                      <div className="form-group row m-1">
                        <label className="text-sm col-sm-2 col-form-label text-right">Rate</label>
                        <div className="col-sm-9">
                          <div className="row mt-2">
                          <div className="text-sm col-sm-2 col-form-label text-small text-right">Work time <span className="text-danger">*</span> </div>
                          <div className="col-sm-4">
                              <div className="input-group">
                                <CurrencyInput
                                  id="txt_Work_time_rate"
                                  name="input-name"                                 
                                  placeholder="Please specify only in numbers."
                                  className="form-control form-control-sm"
                                  decimalsLimit={2}
                                  decimalScale={2}
                                  value={data_model_position_pos_rate_WT}
                                  onValueChange={(value) => onValueChange_model_position_pos_rate(value , "wt")}
                                />
                                <div className="input-group-append">
                                  <span className="input-group-text text-sm">
                                    <small>baht/hr.</small>
                                  </span>
                                </div>
                              </div>
                          </div>

                            {isSVOT === true &&
                            <>
                              <div className="text-sm col-sm-2 col-form-label text-small text-right">Over time <span className="text-danger">*</span> </div>
                                <div className="col-sm-4">
                                    <div className="input-group">
                                        <CurrencyInput
                                          id="txt_OT_rate"
                                          className="form-control form-control-sm"
                                          placeholder="Please specify only in numbers."
                                          decimalsLimit={2}
                                          decimalScale={2}
                                          value={data_model_position_pos_rate_OT}
                                          onValueChange={(value) => onValueChange_model_position_pos_rate(value , "ot")}
                                        />
                                        <div className="input-group-append">
                                          <span className="input-group-text text-sm">
                                            <small>baht/hr.</small>
                                          </span>
                                        </div>
                                      </div>
                                </div>
                              
                              </>
                              }
                          </div>

                          <div className="row mt-2">
                            <div className="text-sm col-sm-2 col-form-label text-small text-right">Per diem allowance <span className="text-danger">*</span> </div>
                            <div className="col-sm-4">
                              <div className="input-group">
                                  <CurrencyInput
                                    id="txt_pos_rate_exp_extra"
                                    className="form-control form-control-sm"
                                    placeholder="Please specify only in numbers."
                                    decimalsLimit={2}
                                    decimalScale={2}
                                    value={data_model_position_pos_rate_exp_extra}
                                    onValueChange={(value) => onValueChange_model_position_pos_rate(value , "extra")}
                                  />
                                  <div className="input-group-append">
                                    <span className="input-group-text text-sm">
                                      <small>baht/day</small>
                                    </span>
                                  </div>
                                </div>
                            </div>

                            <div className="text-sm col-sm-2 col-form-label text-small text-right">Travel <span className="text-danger">*</span> </div>
                            <div className="col-sm-4">
                              <div className="input-group">
                                <CurrencyInput
                                  id="txt_pos_rate_exp_travel"
                                  className="form-control form-control-sm"
                                  placeholder="Please specify only in numbers."
                                  decimalsLimit={2}
                                  decimalScale={2}
                                  value={data_model_position_pos_rate_exp_travel}
                                  onValueChange={(value) => onValueChange_model_position_pos_rate(value , "travel")}
                                />
                                <div className="input-group-append">
                                  <span className="input-group-text text-sm">
                                    <small>baht/km.</small>
                                  </span>
                                </div>
                              </div>

                            </div>

                          </div>

                        </div>
                      </div>


                      <div className="form-group row m-1">
                          <label className="text-sm col-sm-2 col-form-label text-right">Authority
                          <br/>
                          <HtmlTooltip
                            title={
                              <React.Fragment>
                                <div className="text-left">
                                  <p> <span className={ConfigETC.Timesheet_SelfApprove}>Self-Approve</span> <br/> Can approve yourself.</p>
                                  <p><span className={ConfigETC.Timesheet_Approver}>Approver</span><br/> Approve lower positions.</p>
                                  <p><span className={ConfigETC.Timesheet_Reviewer}>Reviewer</span><br/> Review lower positions.</p>
                                  
                              </div> 
                              </React.Fragment>
                            }
                          >
                            <i className="fas fa-info-circle "  ></i>
                          </HtmlTooltip>

                          </label>
                          <div className="col-sm-9">
                          <div className="row mt-2">
                            <div className="text-sm col-sm-2 col-form-label text-small text-right">Timesheet</div>

                            <div className="col-sm-4">
                                <div className="form-group clearfix m-0">
                                  <div className="icheck-primary d-inline">
                                    <input
                                      type="radio"
                                      id="chk_self_approve"
                                      value="3"
                                      name="chk_Timesheet"
                                      checked={selectedTimesheet === "3"}
                                      onChange={(e) => onChange_Radio(e , "TS")} 
                                    />
                                    <label htmlFor="chk_self_approve">
                                      <span className={ConfigETC.Timesheet_SelfApprove}>Self-Approve</span>
                                    </label>
                                  </div>
                                </div>
                                <div className="form-group clearfix m-0">
                                  <div className="icheck-primary d-inline">
                                    <input
                                      type="radio"
                                      id="chk_approver"
                                      value="2"
                                      name="chk_Timesheet"
                                      checked={selectedTimesheet === "2"}
                                      onChange={(e) => onChange_Radio(e , "TS")} 
                                    />
                                    <label htmlFor="chk_approver">
                                      <span className={ConfigETC.Timesheet_Approver}>Approver</span>
                                    </label>
                                  </div>
                                </div>
                                <div className="form-group clearfix m-0">
                                  <div className="icheck-primary d-inline">
                                    <input
                                      type="radio"
                                      id="chk_reviewer"
                                      value="1"
                                      name="chk_Timesheet"
                                      checked={selectedTimesheet === "1"}
                                      onChange={(e) => onChange_Radio(e , "TS")} 
                                    />
                                    <label htmlFor="chk_reviewer">
                                    <span className={ConfigETC.Timesheet_Reviewer}>Reviewer</span>
                                    </label>
                                  </div>
                                </div>
                                <div className="form-group clearfix m-0">
                                  <div className="icheck-primary d-inline">
                                    <input
                                      type="radio"
                                      id="chk_none"
                                      value="0"
                                      name="chk_Timesheet"
                                      checked={selectedTimesheet === "0"}
                                      onChange={(e) => onChange_Radio(e , "TS")} 
                                    />
                                    <label htmlFor="chk_none">
                                    <span className={ConfigETC.Timesheet_None}>None</span>
                                    </label>
                                  </div> 
                                </div>                                                                                     
                              </div>
                            
                          

                            <div className="text-sm col-sm-2 col-form-label text-small text-right">Timeoff</div>
                                  <div className="col-sm-4">
                                    <div className="form-group clearfix m-0">
                                      <div className="icheck-primary d-inline">
                                        <input
                                          type="radio"
                                          id="chk_Timeoff_self_approve"
                                          value="3"
                                          name="chk_Timeoff"
                                          checked={selectedTimeoff === "3"}
                                          onChange={(e) => onChange_Radio(e , "TO")}
                                        />
                                        <label htmlFor="chk_Timeoff_self_approve">
                                          <span className={ConfigETC.Timeoff_SelfApprove}>Self-Approve</span>
                                        
                                        </label>
                                      </div>
                                    </div>
                                    <div className="form-group clearfix m-0">
                                      <div className="icheck-primary d-inline">
                                        <input
                                          type="radio"
                                          id="chk_Timeoff_approver"
                                          value="2"
                                          name="chk_Timeoff"
                                          checked={selectedTimeoff === "2"}
                                          onChange={(e) => onChange_Radio(e , "TO")}
                                        />
                                        <label htmlFor="chk_Timeoff_approver">
                                          <span className={ConfigETC.Timeoff_Approver}>Approver</span>
                                          &nbsp;
                                          
                                        </label>
                                      </div> 
                                    </div>
                                    <div className="form-group clearfix m-0">
                                      <div className="icheck-primary d-inline">
                                        <input
                                          type="radio"
                                          id="chk_Timeoff_reviewer"
                                          value="1"
                                          name="chk_Timeoff"
                                          checked={selectedTimeoff === "1"}
                                          onChange={(e) => onChange_Radio(e , "TO")}
                                        />
                                        <label htmlFor="chk_Timeoff_reviewer">
                                          <span className={ConfigETC.Timeoff_Reviewer}>Reviewer</span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="form-group clearfix m-0">
                                      <div className="icheck-primary d-inline">
                                        <input
                                          type="radio"
                                          id="chk_Timeoff_none"
                                          value="0"
                                          name="chk_Timeoff"
                                          checked={selectedTimeoff === "0"}
                                          onChange={(e) => onChange_Radio(e , "TO")} 
                                        />
                                        <label htmlFor="chk_Timeoff_none">
                                          <span className={ConfigETC.Timeoff_None}>None</span>
                                        </label>
                                      </div>  
                                                   
                                    </div>
                                  </div>                                                                      
                            </div>
                            
                            
                          </div>
                          </div>
                      


                      <div className="form-group row">
                            <label className="text-sm col-sm-2 col-form-label text-right">
                              Status{" "}
                            </label>
                            <div className="col-sm-10">
                                <BootstrapSwitchButton
                                    onChange={(checked) => { setIsPositionStatus(checked) }}
                                    checked={isPositionStatus}
                                    width={ConfigETC.SwitchButton_in_active_width} 
                                    onlabel={ConfigETC.SwitchButton_active_text}
                                    onstyle={ConfigETC.SwitchButton_active_color}
                                    offlabel={ConfigETC.SwitchButton_inactive_text}
                                    offstyle={ConfigETC.SwitchButton_inactive_color}
                                    size="xs"
                                />

                            

                            </div>
                          </div>
                      

                      
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer margin">

                    <a href="#!" className="btn btn-default" title="ยกเลิก" onClick={() => onclickCancel()}>
                      <i className="fa  fa-times" /> Cancel
                    </a>
                    {(isPermissionAdd || isPermissionEdit) &&              
                        <a href="#!" className="btn btn-primary float-right" title="เพิ่ม" onClick={() => onclickSavePositonAE()} >
                          <i className="fa fa-save"/> Save
                        </a>
                    } 
                  </div>
                  {/* end loading */}
                </div>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}
    </>
  );
}

export default M_position_ae;
